document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.product__button[data-product-id]');
    if (!buttons.length) return;

    buttons.forEach((button) => {
        button.addEventListener('click', async (e) => {
            e.preventDefault();

            const id = button.getAttribute('data-product-id');
            if (!id) return;

            button.classList.add('loading');

            try {
                // Shopify AJAX add
                const res = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: Number(id),
                        quantity: 1,
                    }),
                });

                if (!res.ok) throw new Error('Add to cart error');

                // Далі оновлюємо cart.js
                await fetch('/cart.js')
                    .then((r) => r.json())
                    .then((cart) => {
                        // Якщо твоя корзина потребує кастомного рендеру — викликати тут
                        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
                    });

                // Відкриваємо кастомну корзину
                if (window.flsCart && typeof window.flsCart.open === 'function') {
                    window.flsCart.open();
                }
            } catch (error) {
                console.error(error);
            }

            button.classList.remove('loading');
        });
    });
});
